import { createSelector } from '@reduxjs/toolkit';
import { not } from 'fp-ts/lib/Predicate';
import * as ProductList from '../../data/productList';
import { RootState } from '../../store';
import * as ProductData from './productData';

/**
 * The raw Layouts store state
 */
export const layouts = (state: RootState) => state.loading;

/**
 * The furniture and sofas which currently need to be added to the scene
 */
export const currentlyLeftToLoad = createSelector(
    layouts,
    ProductData.discontinuedProducts,
    (state, discontinued) => ({
        furniture:
            discontinued !== undefined
                ? state.furnitureLeftToLoad.filter(
                      not(ProductList.includesLayoutFurniture(discontinued)),
                  )
                : null,
        discontinued:
            discontinued !== undefined
                ? state.furnitureLeftToLoad.filter(
                      ProductList.includesLayoutFurniture(discontinued),
                  )
                : null,
        sofas: state.sofasLeftToLoad,
    }),
);

export const singleProductIdToLoad = createSelector(layouts, state => state.singleProductIdToLoad);

export const totalSimpleFurnitureToLoad = createSelector(
    layouts,
    ProductData.discontinuedProducts,
    (state, discontinued) =>
        discontinued !== undefined
            ? state.totalFurnitureToLoad.filter(
                  not(ProductList.includesLayoutFurniture(discontinued)),
              )
            : null,
);
export const totalModularFurnitureToLoad = createSelector(
    layouts,
    state => state.totalModularFurnitureToLoad,
);

export const whatIsLoading = createSelector(layouts, state => state.kind);

export const currentlyLoading = createSelector(layouts, state => state.currentlyLoading);
export const currentLoadingId = createSelector(layouts, state => state.currentLoadingId);
